import { useMutation } from "@apollo/client";
import { Button, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

import { APPROVE_IDENTITY } from "../../../../graphql/mutations/management";
import { GET_MEMBER_LIST } from "../../../../graphql/queries/management";

import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const ApproveIdentityForm = ({ handleClose }) => {
  const management = useSelector((state) => state.management);
  const { identity } = management;

  const [approveMemberIdentity, { loading }] = useMutation(APPROVE_IDENTITY, {
    variables: {
      id: identity.id,
    },
    refetchQueries: [{ query: GET_MEMBER_LIST }],
    onCompleted: (data) => {
      if (data.approveMemberIdentity) {
        handleClose();
        showSuccessToast();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    approveMemberIdentity();
  };

  return (
    <div className="notolao">
      <h5>ຊື່ບັດປະຊາຊົນ : {identity.cardName}</h5>
      <h5>ເລກບັດປະຊາຊົນ : {identity.cardNo}</h5>
      <h5 className="text-center mt-3">ຮູບບັດປະຊາຊົນ</h5>
      <img
        src={identity.cardImageUrl}
        alt="card-img"
        className="img-thumbnail"
      />
      {!identity.isVerified && (
        <div className="text-center m-2">
          <Button onClick={handleSubmit}>
            {loading && <Spinner as="span" animation="grow" size="sm" />}
            ຢືນຢັນບັດປະຊາຊົນ
          </Button>
        </div>
      )}
    </div>
  );
};

export default ApproveIdentityForm;
